// extracted by mini-css-extract-plugin
export default {"desktopGalleryContainer":"Home_desktopGalleryContainer__gQydv","mobileGalleryContainer":"Home_mobileGalleryContainer__w6sGz"};